import React from 'react';
import './Advert.css';
import packageIcon from '../assets/img/package.svg';

class Advert extends React.Component {
  constructor() {
    super();

    this.state = {
      adTitle: 'Zrób komuś prezent!',
      adText: 'Czy wiesz, że w naszym gabinecie można zakupić bony podarunkowe?',
      adText2: 'Ofiarowanie komuś zdrowia, to najlepszy z gestów.'
    }
  }

  render() {
    return (
      <section className="promotion" id="promo">
        <div className="container">
          <div>
            <h1>{this.state.adTitle}</h1>
            <h3>{this.state.adText}</h3>
            <p>{this.state.adText2}</p>
          </div>
          <div>
            <img src={packageIcon} alt="Promocja na usługi podologiczne"></img>
          </div>
        </div>
      </section>
    );
  }
}

export default Advert;
